import { render, staticRenderFns } from "./UserProfileUpload.vue?vue&type=template&id=5ba15f68"
import script from "./UserProfileUpload.vue?vue&type=script&lang=js"
export * from "./UserProfileUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports